import { connect } from "react-redux";
import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import Button from '@material-ui/core/Button';
import TextField from "../../Partials/Material/TextField";
import Card from '@material-ui/core/Card';
// import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import Comment from "./Comment";

interface StateInterface {
  message: string;
	comments: EventInterface[];
	isSaving: boolean;
}

class Memo extends Component {
  public state: StateInterface = {
    message: "",
		comments: [],
		isSaving: false
  };

  constructor(public props) {
    super(props);
  }

	public componentWillMount() {
    this.setState({
      message: this.props.entity?.note
    })

		this.props.dispatch({
			type: Constants.GLOBAL_EVENT_CREATE_CLEAR
		});
  }

  public componentDidMount () {
    if (this.props.relations) {
      const comments = document.getElementById(`memo-comments`);

      this.fetchEntityEvents(this.scrollToTop.bind(this, comments));
    }
  }

	public fetchEntityEvents = (callback?) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        ...this.props.relations,
				eventTypeId: 17
      },
      onSuccess: data => {
        const comments: EventInterface[] = data.events
          .filter((event: EventInterface) => !event.removed);

        this.setState({
          comments: [...comments],
          fetchingComments: false
        }, () => {
					if(!!this.props.updateMemoStatus) {
						if(this.state.comments?.length > 0) {
              this.props.updateMemoStatus();
            }
					}
					if (typeof callback === "function") {
						callback();
					}
				});
      }
    });
  }

	public createComment = (): any => {
		return this.saving(() => {
			this.props.dispatch({
				type: Constants.GLOBAL_EVENT_CREATE_START,
				payload: {
					content: {
						note: this.state.message
					},
					// snoozeDate: snoozeDate,
					eventTypeId: 17, // note
					...this.props.relations
				},
				onSuccess: () => {
					this.setState({
						message: "",
						isSaving: false
          }, this.props.saveDraft(''));
          
          if (this.props.unit) {
            this.props.dispatch({
              type: Constants.GLOBAL_UNIT_UPDATE_SUCCESS,
              payload: {
                unit: {...this.props.unit, hasMemos: true}
              }
            });
          }

					const comments = document.getElementById(`memo-comments`);
					this.fetchEntityEvents(this.scrollToTop.bind(this, comments));
					
					// if (typeof this.props.fetchEntities === "function") {
					// 	this.props.fetchEntities();
					// }
				},
				onError: () => {
					this.setState({
						isSaving: false
          });
				}
			});
		});
  }

	public scrollToTop(element) {
		setTimeout(() => {
			return element && element.scroll({top: element?.scrollHeight });
		}, 100);	
	}

  public render() {
    return (
			<div className="component">
        {/* {
          this.state.isSaving && (
            <div className="component-spinner-wrapper">
              <CircularProgress />
            </div>
          )
        } */}

        <Card className="card">
					<div className="memo">
						<div className="section">
							<div id={`memo-comments`} className="comments">
								{
									this.state.comments
									.sort((comment1: EventInterface, comment2: EventInterface) => {
										if (comment1.createdAt > comment2.createdAt) {
											return 1;
										}
						
										if (comment1.createdAt < comment2.createdAt) {
											return -1;
										}
						
										return  0;
									})
									.map(comment => {
										return (
											<Comment 
												{...this.props}
												key={`comment-${comment?.id}`}
												comment={comment}
											/>
										);
									})
								}
							</div>
							<div className="new-comment">
								<TextField
									autoFocus={true}
									autoComplete="off"
									className="comment-textfield"
									type="text"
                  rowsMax={5}
                  inputProps={{ maxLength: 255 }}
                  multiline={true}
									label={this.trans("message")}
									value={this.state.message}
									onChange={e => this.setState({message: e.target.value, requestError: false}, this.props.saveDraft(e.target.value))}
									variant="standard"
									error={!!this.getErrorFor("content.note")}
									helperText={this.getErrorFor("content.note")}
								/>

								<Button
									color="primary"
									onClick={() => this.setState({requestError: false}, this.createComment)}
									disabled={this.state.isSaving}
								>
									{this.trans("button-add")}
								</Button>
							</div>
							{
								!!this.props.additionalElement && (
									<div style={{paddingLeft: "10px"}}>
										{this.props.additionalElement}
									</div>
								)
							}
						</div>
					</div>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    events: state.events,
    tasks: state.tasks,
    component: state.memo,
    globalTypes: state.globalTypes,
    properties: state.properties,
    units: state.units
  };
};

export default connect(mapStateToProps)(
  Memo
);
